import { render } from "./AddCategorieArticle.vue?vue&type=template&id=d470b2e6&ts=true"
import script from "./AddCategorieArticle.vue?vue&type=script&lang=ts"
export * from "./AddCategorieArticle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__